import {UseQueryOptions, useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {axiosBffFetch} from '../../../axios/axiosBffFetch';
import {AskDetail, AskDetailRequestParams, AskDetailResponse} from '../type';

const useAskDetailQueryHook = (
  variables: AskDetailRequestParams,
  options?: UseQueryOptions<AskDetail>
) =>
  useQuery<AskDetail>({
    queryKey: useAskDetailQueryHook.getKey(variables),
    queryFn: async () => {
      const {questionId, projectId} = variables;
      if (!questionId) {
        throw new Error('문의 ID가 존재하지 않습니다.');
      }
      const result: AxiosResponse<AskDetailResponse> = await axiosBffFetch(
        `/api/ask/detail/${questionId}`,
        {
          params: {projectId},
        }
      );
      if (!result.data?.data?.question) {
        throw new Error('데이터가 존재하지 않습니다.');
      }
      return result.data.data.question;
    },
    ...options,
  });

useAskDetailQueryHook.getKey = (variables: AskDetailRequestParams) => [
  'askDetail',
  variables,
];

export default useAskDetailQueryHook;
